import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import { CountTypeStrings } from 'enums/CountType'
import messageUtil from 'utils/messageUtil'

const StyledName = styled.span.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.selectedTerm
})`
  font-weight: ${sys.fontWeight.semibold};
`

const Title = ({
  countType,
  selectionName,
  renderContent
}: {
  countType: CountTypeStrings
  selectionName: React.ReactNode
  renderContent?: () => React.ReactNode
}) => (
  <div>
    {renderContent ? (
      renderContent()
    ) : (
      <>
        <StyledName>{selectionName}</StyledName>
        {messageUtil.countType(countType)}
      </>
    )}
  </div>
)

export default Title
